import { get } from '@client/lib/request';
import { DataLayer } from '@shared/types/data-layer';

export const updateGeneratedUrl = (initialData: DataLayer) => {
    const search =
        initialData.generatedUrl?.split('?')?.length === 2
            ? `?${initialData.generatedUrl.split('?')[1]}`
            : '';

    return `${window.location.pathname}${search}`;
};

export const loadTrackData = () => {
    return get('/api/tracking/clients/me/events')
        .then(data => {
            const initialData = data || {};
            initialData.generatedUrl = updateGeneratedUrl(initialData);

            return initialData;
        })
        .catch(() => ({}));
};
